<template>
    <div class="">
        <div class="container">
            <div v-if="checkingForm || loadingFormData">
                <div class="spacer s30"></div>
                <h3>
                    <span class="loading-spinner"><font-awesome-icon icon="spinner" class="fa-spin 3x" /></span>&nbsp; {{ status }}
                </h3>
            </div>

            <div class="spacer s10 desktop"></div>
            <!-- {{ allVesselCrewIDs }} -->
            <!-- {{ formData }} -->
            <!-- {{ formMeta }} -->

            <div v-if="formLoaded">
                <div v-if="accessAllowed">
                    <div v-if="requiresLogin">
                        <div v-if="userHasAccess">
                            <div v-if="isSinglePage">
                                <CustomLogSinglePage :allVesselCrewIDs="allVesselCrewIDs" />
                            </div>
                            <div v-else>
                                <CustomLogsTabbedPage :allVesselCrewIDs="allVesselCrewIDs" />
                            </div>
                        </div>
                        <div v-else>
                            <div class="spacer s30"></div>
                            {{ formMessage }} <br />
                            <div class="spacer s30"></div>
                            <div v-if="!isLoggedIn" class="button is-primary" @click="showLogin()">Login required</div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="isSinglePage">
                            <CustomLogSinglePage :allVesselCrewIDs="allVesselCrewIDs" />
                        </div>
                        <div v-else>
                            <CustomLogsTabbedPage :allVesselCrewIDs="allVesselCrewIDs" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="spacer s30"></div>
                    {{ formMessage }}
                </div>
            </div>
            <div v-else>
                <div class="spacer s30"></div>
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '../main.js';
import { collection, query, where, doc, onSnapshot, setDoc, getDocs, getDoc, orderBy, limit } from 'firebase/firestore';
import NProgress from 'nprogress';
import { getFunctions, httpsCallable } from 'firebase/functions';

import CustomLogsTabbedPage from './subcomponents/CustomLogsTabbedPage.vue';
import CustomLogSinglePage from './subcomponents/CustomLogSinglePage.vue';

const functions = getFunctions();
const aus_functions = getFunctions(undefined, 'australia-southeast1');
const addRevision = httpsCallable(functions, 'addRevision');
const loadPublicVesselData = httpsCallable(aus_functions, 'asset_functions-loadPublicVesselData_G2');

export default {
    props: {
        // sentCustomLog: Object,
        webLink: String
    },

    mounted() {
        let hasParam = this.$route.query && this.$route.query.x;
        if (hasParam) {
            this.xID = this.$route.query.x ? this.$route.query.x : '';
            this.vID = this.$route.query.v ? this.$route.query.v : '';
            this.aID = this.$route.query.a ? this.$route.query.a : '';
            this.eID = this.$route.query.e ? this.$route.query.e : '';
            this.fleetOverride = this.$route.query.l ? (this.$route.query.l == '1' ? true : false) : false;
            // passenger manifest and trip params:
            this.tID = this.$route.query.tid ? this.$route.query.tid : '';
            this.pID = this.$route.query.pid ? this.$route.query.pid : '';
            this.pName = this.$route.query.pname ? this.$route.query.pname : '';
            this.linksToManifest = this.tID != '' && this.pID != '' ? true : false;
        } else {
            this.xID = this.webLink ? this.webLink : '';
        }

        let self = this;
        if (this.xID != '') {
            this.checkCodeExists();
        } else {
            setTimeout(() => {
                self.checkingForm = false;
                self.status = 'No log found.';
                self.errorMessage = 'No log found.';
            }, 1000);
        }
        this.$store.dispatch('checkWebVersionCloud');
    },

    components: {
        CustomLogsTabbedPage,
        CustomLogSinglePage
    },

    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        isLoggedIn() {
            return this.user && this.user.uid && this.user.uid != '';
        },
        userData() {
            return this.$store.getters.getSubscriptionInfo;
        },
        userID() {
            return this.userData.userid;
        },
        userFirstName() {
            return this.userData.username.split(' ')[0];
        }
    },

    data() {
        return {
            code: '',
            currentWebLink: '',
            checkingForm: true,
            formExists: false,
            loadingFormData: false,
            hasData: false,
            status: 'Checking if log exists..',
            formMessage: '',
            formLoaded: false,
            errorMessage: '',

            formMeta: {},
            formData: {},

            xID: '',
            vID: '',
            aID: '',
            eID: '',
            fleetOverride: '',
            accessAllowed: false,
            requiresLogin: false,

            userHasAccess: false,
            allVesselCrewIDs: [],

            customFields: [],
            isSinglePage: false,
            //
            tID: '',
            pID: '',
            pName: '',
            linksToManifest: false,
            realVesselID: ''
        };
    },

    methods: {
        async checkCodeExists() {
            this.errorMessage = '';

            const docRef = doc(db, 'vesselWebLinkIDs', this.xID);
            // console.log('Checking for log with web link ID:', this.xID);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                this.formMeta = docSnap.data();
                this.formMeta.vID = this.vID;
                this.formMeta.aID = this.aID;
                this.formMeta.eID = this.eID;
                this.formMeta.fleetOverride = this.fleetOverride;
                if (docSnap.data().vesselID) {
                    let vesselID = docSnap.data().vesselID;
                    this.$store.dispatch('setCurrentVessel', { vesselID });
                }
                let logMeta = this.formMeta;
                this.$store.dispatch('setCurrentLogMeta', { logMeta });
                setTimeout(() => {
                    this.status = 'Loading settings...';
                    this.formExists = true;
                    this.loadingFormData = true;
                    this.checkingForm = false;
                    this.loadFormData();
                }, 500);
            } else {
                this.checkingForm = false;
                this.status = 'This form could not be loaded.';
                this.errorMessage = 'No custom log found.';
            }
        },

        loadFormData() {
            if (this.formMeta.logType == 'custom-log') {
                this.hasData = true;
                this.status = 'Form located. Updating fields...';
                setTimeout(() => {
                    this.loadCustomForm();
                }, 500);
            }
        },

        async loadCustomForm() {
            // console.log(this.formMeta);
            const isHelper = this.formMeta.isHelper ?? false;
            const coll = this.formMeta.isFleet ? 'companies/' : 'vessels/';

            const docRef = isHelper
                ? doc(db, 'helperCustomLogs', this.formMeta.logID)
                : doc(db, coll + this.formMeta.vesselID + '/customChecklists', this.formMeta.logID);
            // console.log('Loading form data from', docRef.path);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let archived = docSnap.data().archived ? docSnap.data().archived : false;
                if (archived) {
                    this.errorMessage = 'This form has been archived and is no longer available, sorry.';
                    this.loadingFormData = false;
                } else {
                    let data = docSnap.data();
                    data.id = docSnap.id;
                    this.currentWebLink = docSnap.data().webLink ? docSnap.data().webLink : '';
                    data.linkedTrainingSchedules = docSnap.data().linkedTrainingSchedules ? docSnap.data().linkedTrainingSchedules : [];
                    if (this.xID != this.currentWebLink) {
                        this.loadingFormData = false;
                        this.errorMessage = 'Form expired. Access denied.';
                        return;
                    }
                    this.formData = data;
                    this.isSinglePage = data.webLinkFormIsSinglePage ? data.webLinkFormIsSinglePage : false;
                    this.formData.linksToManifest = this.linksToManifest;
                    if (this.linksToManifest) {
                        this.formData.tripID = this.tID;
                        this.formData.passengerID = this.pID;
                        this.formData.passengerName = this.pName;
                    }
                    //
                    let logData = this.formData;
                    this.$store.dispatch('setCurrentLogData', { logData });
                    if (!isHelper) await this.loadVesselData();
                    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
                    await sleep(500);
                    let editToken = this.eID != '' ? this.eID : '';
                    let tokenValid = false;
                    if (editToken != '') {
                        tokenValid = await this.checkEditToken();
                    } else {
                        tokenValid = true;
                    }
                    if (tokenValid) this.validateAccess();
                }
            } else {
                this.formMessage = 'This form is not available, sorry.';
                this.loadingFormData = false;
            }
        },

        async checkEditToken() {
            let editToken = this.eID != '' ? this.eID : '';
            if (editToken == '') return false;
            let docRef;
            // console.log(this.fleetOverride, editToken, this.realVesselID);

            if (this.fleetOverride) {
                docRef = doc(db, 'companies', this.formMeta.vesselID, 'customLogs', this.vID);
            } else {
                docRef = doc(db, 'vessels', this.realVesselID, 'customLogs', this.vID);
            }

            // console.log('Checking edit token for', docRef.path);

            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let currentToken = docSnap.data().editToken ?? '';
                if (this.eID == currentToken) {
                    // console.log('Edit token valid');
                    return true;
                } else {
                    // console.log('Edit token invalid');
                    this.loadingFormData = false;
                    this.formLoaded = true;
                    this.formMessage = 'This form is not available, sorry.';
                    this.accessAllowed = false;
                    return false;
                }
            }
        },

        async loadVesselData() {
            let assetID = this.aID != '' ? this.aID : this.formData.realAssetID ? this.formData.realAssetID : this.formMeta.vesselID;
            this.realVesselID = assetID;
            const result = await loadPublicVesselData({ vesselID: assetID });
            if (result.data.success) {
                let allData = result.data.vesselData;
                let ch1 = allData.listOfCrewIDs ? allData.listOfCrewIDs : [];
                this.allVesselCrewIDs = [...ch1];
                this.$store.dispatch('UPDATESELECTEDVESSEL', { allData });
            }
        },

        validateAccess() {
            if (!this.formData.allowWebLink) {
                this.loadingFormData = false;
                this.formLoaded = true;
                this.formMessage = 'This form is not available, sorry.';
                this.accessAllowed = false;
            } else {
                // check if is public or crew restricted
                this.accessAllowed = true;
                if (this.formData.webLinkCrewOnly) {
                    this.status = 'Checking user access...';
                    this.requiresLogin = true;
                    setTimeout(() => {
                        this.checkUserAccess();
                    }, 1000);
                } else {
                    this.loadingFormData = false;
                    this.formLoaded = true;
                }
            }
        },

        checkUserAccess() {
            let self = this;
            // console.log(this.isLoggedIn,this.allVesselCrewIDs,this.userID);
            this.userHasAccess = this.isLoggedIn && this.allVesselCrewIDs.includes(this.userID);
            this.formMessage = this.userHasAccess ? 'Access permitted..' : 'This form is only available to authorised users.';
            self.loadingFormData = false;
            self.formLoaded = true;
        },

        showLogin() {
            return;
            // this.$router.push({
            //     name: 'UserLogin',
            //     params: {
            //         return: true
            //     }
            // });
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    max-width: 1000px !important;
    padding: 1rem 20px !important;
}

::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: pink;
    letter-spacing: 1px;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: pink;
    letter-spacing: 1px;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: pink;
    letter-spacing: 1px;
}

:-moz-placeholder {
    /* Firefox 18- */
    color: pink;
    letter-spacing: 1px;
}

h1 {
    color: #444;
}

.toggle {
    position: fixed;
    top: 65px;
    right: 10px;
    background: cadetblue;
    color: #fff;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        background: mediumseagreen;
    }
}

// .teds-box {
//     border: 10px solid orange;
//     background-color: black;
//     color: orange;
//     font-size: 40px;
//     padding: 50px;
//     border-radius: 50px;
// }

@media screen and (max-width: 769px) {
    .desktop {
        display: none;
    }
}
</style>
